module.exports = __webpack_public_path__ + "img/girl2.28bd9a64.svg";